export default __webpack_public_path__ + "static/thomas-11438ba50009f4e6dc6ca4edf9217b6d.jpg";